(function () {
  if (window.EpalCollectionWishlist) return;
  window.EpalCollectionWishlist = true;

  var proxy = '/apps/giftregistry';
  var api = proxy + '/api';
  var contextPromise;

  function getContext() {
    if (contextPromise) return contextPromise;
    contextPromise = fetch(proxy + '/manage', { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var element = doc.getElementById('giftreggie-context');
        return element ? JSON.parse(element.textContent) : null;
      })
      .catch(function () { return null; });
    return contextPromise;
  }

  function currentVariants(registryId, productId) {
    return fetch(api + '/registry/' + registryId + '/products', {
      credentials: 'same-origin'
    })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        var product = data && data.products && data.products.filter(function (item) {
          return String(item.id) === String(productId);
        })[0];
        return product && product.variants ? product.variants.slice() : [];
      })
      .catch(function () { return []; });
  }

  function setStatus(button, message) {
    var wrap = button.closest('.epal-grid-wishlist-wrap');
    var status = wrap && wrap.querySelector('[data-epal-grid-wishlist-status]');
    if (status) status.textContent = message || '';
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-epal-grid-wishlist]');
    if (!button) return;

    event.preventDefault();

    var productId = button.dataset.productId;
    var variantId = parseInt(button.dataset.variantId, 10);
    if (!productId || !variantId || button.disabled) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    setStatus(button, 'Bæti á óskalista…');

    getContext()
      .then(function (context) {
        if (!context || !context.registries || !context.registries.length) {
          window.location.href = proxy + '/create';
          return null;
        }

        var registryId = context.registries[0].id;
        return currentVariants(registryId, productId).then(function (variants) {
          var existing = variants.find(function (variant) {
            return parseInt(variant.id, 10) === variantId;
          });

          if (existing) existing.quantity = (parseInt(existing.quantity, 10) || 0) + 1;
          else variants.push({ id: variantId, quantity: 1 });

          return fetch(api + '/registry/' + registryId + '/products', {
            method: 'PUT',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ products: [{ id: String(productId), variants: variants }] })
          });
        });
      })
      .then(function (response) {
        if (!response) return;
        if (!response.ok) throw new Error('Wishlist request failed');
        button.setAttribute('aria-pressed', 'true');
        button.title = 'Bætt á óskalista';
        setStatus(button, 'Bætt á óskalista');
      })
      .catch(function () {
        setStatus(button, 'Ekki tókst að bæta á óskalista');
      })
      .finally(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  });
})();
